<template>
  <div class="kp-list-group-item clearfix">
    <label
      class="kp-row box-title box-title__button box-radio"
      @click="boxUpdateConfig({ item: 'advanced', key: 'exibition_mode', value });">
      <input type="radio" :checked="boxConfig.advanced.exibition_mode === value">
      <span class="box-title__label has-icon">{{label}}</span>
    </label>
    <div v-show="boxConfig.advanced.exibition_mode === value">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: [
    'value',
    'label',
  ],
  methods: mapActions([
    'boxUpdateConfig',
  ]),
  computed: mapGetters({
    boxConfig: 'boxConfig',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?78f910f6
 **/